let socket = null;
export let imageUrl = ''

const uploadImgToCloud = async ({ url, fileToSend }) => {
    const response = await fetch(url, {
        method: 'PUT',
        body: fileToSend,
    });
    if (!response.ok) {
        throw new Error(response.statusText);
    }
    const img = new URL(url);
    img.search = '';
    return img.href;
};

const dataURItoBlob = (dataURI, type) => {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type });
}

export const sendImg = async ({ url, file }) => {
    const fileToSend = dataURItoBlob(file.blob, file.type);
    const imgHref = await uploadImgToCloud({ url, fileToSend });
    return imgHref;
};

const sendSocketMessage = (params) => {
    socket.send(JSON.stringify(params));
};
export const openWebSocket = ({
    token,
    merchantId
}) => {
    const ENV = localStorage.getItem('envSquadded');
    const SQUAD_ORIGIN = ENV === 'STAGING' || ENV === 'DEV' ? 'squad-shopping.com' : 'squadded.co';
    socket = new WebSocket(`wss://api.${SQUAD_ORIGIN}/`);
    socket.addEventListener('message', async (event) => {
        const msg = JSON.parse(event.data)
        const { type } = msg;

        if (type === 'authRequest') {
            sendSocketMessage({
                "type": "authResponse",
                "userToken": token,
                merchantId,
                "session": true
            })
        }
    });
};

export const uploadImage = async ({ image }) => {
    socket.addEventListener('message', async (event) => {
        const msg = JSON.parse(event.data)
        const { type, url } = msg;
        if (type === 'uploadURL') {
            imageUrl = await sendImg({ url, file: image });
        }
    });
    sendSocketMessage({
        "type": "getUploadUrl",
        contentType: image.type || 'image/png',
    })

}